import { GetServerSideProps } from 'next'

import CardLists from '@/components/CardLists/CardLists'
import DecksTable from '@/components/DecksTable/DecksTable'
import DefaultHead from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import MidBanner from '@/components/MidBanner/MidBanner'
import Panels from '@/components/Panels/Panels'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import SubMenu from '@/components/SubMenu/SubMenu'
import Tabs from '@/components/Tabs/Tabs'
import { CommandersPageProps } from '@/types/page'
import { COLORS, TIMESPANS } from '@/utils/constants'
import { serverSidePropsFor } from '@/utils/helpers.server'
import useDirectories from '@/utils/useDirectories'

const SUBMENU_ITEMS = [
  { name: 'Past 2 Years', url: '/commanders' },
  { name: 'Past Month', url: '/commanders/month' },
  { name: 'Past Week', url: '/commanders/week' },
]

const colorMenuItems = (cid: string) => [
  { name: 'Commanders', url: `/commanders/${cid}` },
  { name: 'Staples', url: `/commanders/${cid}/staples` },
  { name: 'Mana Staples', url: `/commanders/${cid}/mana-staples` },
]

const CommandersPage = ({ data }: CommandersPageProps) => {
  const { subpage, subsubpage, subsubsubpage } = useDirectories()

  const isColorPage = Object.values(COLORS)
    .map((color) => color.toLowerCase())
    .includes(subpage)
  const isTimespanPage = TIMESPANS.includes(subpage)
  const isIndex = !subpage && !subsubpage && !subsubsubpage
  const hasTabs = isColorPage || isTimespanPage
  const showPanels = !hasTabs && subpage !== 'vehicles'
  const topLeftEdge = isColorPage ? !subsubpage : !subpage

  const content =
    subsubsubpage === 'decks' ? (
      // @ts-ignore
      <DecksTable rows={data.table} />
    ) : (
      <>
        <Tabs>{hasTabs && <SubMenu items={isColorPage ? colorMenuItems(subpage) : SUBMENU_ITEMS} />}</Tabs>
        <CardLists
          card={data.container.json_dict.card}
          disabledSortMethods={isColorPage || isIndex || isTimespanPage ? ['percent', 'synergy'] : []}
          initCardLists={data.container.json_dict.cardlists}
          topLeftEdge={topLeftEdge}
        />
      </>
    )

  return (
    <Main artCrop={data.container.json_dict.card?.image_uris[0].art_crop}>
      <DefaultHead data={data} />
      {showPanels ? <Panels data={data} /> : <SimpleHeader>{data.header}</SimpleHeader>}
      <MidBanner />
      {content}
    </Main>
  )
}

export const getServerSideProps: GetServerSideProps<CommandersPageProps> = async ({ req }) =>
  serverSidePropsFor(`${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/commanders/year.json`, req.headers)

export default CommandersPage
